import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'
import { removeScrollbar } from '@src/pages/global.styles'

export const Container = styled.div`
  background-color: white;
  width: 100vw;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  padding: 8px 18px 0px;
  overflow-y: scroll;
  border-bottom: 1px solid rgba(149, 157, 165, 0.2);
  box-shadow: rgba(149, 157, 165, 0.4) 0px -8px 24px;
  ${removeScrollbar};
`
export const NonIdealSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ClearSearchButton = styled.button`
  border: none;
  background-color: transparent;

  padding: 0;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.mainText};
  text-decoration: underline;
  cursor: pointer;
  margin: 0;
  height: 32px;
  margin: 20px;

  &:hover {
    text-decoration: none;
  }
`

export const HeaderContainer = styled.div`
  padding: 16px 16px 8px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 32px 32px 16px 32px;
  }
`
export const Header = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 8px 0;
  color: #2e3333;

  @media (min-width: ${breakpoints.largeTabletMisc}px) {
    margin-bottom: 8px;
    font-size: 24px;
  }
`
